(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalog-filters"] && !Shopify.designMode) return;
  try {
    function applyCatalogFilters(event) {
  const form = event.target.closest('[data-catalog-filters]');
  if (!form) return;
  if (event.type === 'change' && !event.target.matches('select')) return;
  event.preventDefault();
  const tags = [];
  for (const type of ['format', 'support']) {
    const value = form.elements[type].value;
    if (value) tags.push(encodeURIComponent(type + ':' + value));
  }
  window.location.assign(form.dataset.allUrl + (tags.length ? '/' + tags.join('+') : '') + '#catalog-browse');
}
document.addEventListener('change', applyCatalogFilters);
document.addEventListener('submit', applyCatalogFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["catalog-purchase-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
  const widget = event.target.closest('[data-catalog-purchase]');
  if (!widget) return;
  const subscription = widget.querySelector('input[type="radio"]:checked').value === 'subscription';
  const select = widget.querySelector('select[name="selling_plan"]');
  select.disabled = !subscription;
  widget.querySelector('[data-catalog-plan-choice]').hidden = !subscription;
  const price = subscription ? select.selectedOptions[0].dataset.price : widget.dataset.oneTimePrice;
  const label = subscription ? widget.dataset.subscribeLabel : widget.dataset.addLabel;
  const button = widget.closest('form').querySelector('[data-add-to-cart]');
  if (button && button.dataset.productAvailable === 'true') button.textContent = label.replace('__PRICE__', price);
});
  } catch(e) { console.error(e); }
})();

})();
